import LegalLayout, { LegalSection } from "./LegalLayout";
import useSeo from "../hooks/useSeo";

export default function Datenschutz() {
  useSeo({
    title: "Datenschutzerklärung | IYM – Im Your Man",
    description: "Datenschutzerklärung von IYM – Im Your Man, Webdesign & Google Ads Agentur aus Dresden.",
    path: "/datenschutz",
    robots: "noindex, follow",
  });
  return (
    <LegalLayout title="Datenschutzerklärung" updated="Stand: Januar 2026">
      <LegalSection heading="1. Allgemeine Hinweise">
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre
          personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften
          sowie dieser Datenschutzerklärung.
        </p>
        <p>Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
      </LegalSection>

      <LegalSection heading="2. Verantwortliche Stelle">
        <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
        <p>
          Dmitriy Gazarov
          <br />
          Hopfgartenstraße 10
          <br />
          01307 Dresden
          <br />
          Deutschland
          <br />
          E-Mail:{" "}
          <a href="mailto:info.iym24@gmail.com" className="text-[#2c3bff] hover:underline">
            info.iym24@gmail.com
          </a>
        </p>
      </LegalSection>

      <LegalSection heading="3. Hosting und Server-Log-Dateien">
        <p>
          Beim Besuch der Website verarbeitet der Hosting-Anbieter personenbezogene Daten, insbesondere
          sogenannte Server-Log-Dateien. Diese Daten sind technisch erforderlich, um die Website korrekt
          darzustellen und die Sicherheit des Systems zu gewährleisten. Verarbeitet werden können unter
          anderem:
        </p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Uhrzeit der Serveranfrage</li>
          <li>IP-Adresse</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte
          Interesse liegt in der sicheren und stabilen Bereitstellung dieser Website.
        </p>
      </LegalSection>

      <LegalSection heading="4. Cookies">
        <p>
          Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät
          gespeichert werden und bestimmte Informationen enthalten. Beim ersten Besuch der Website können
          Sie über ein Cookie-Banner auswählen, welche Kategorien von Cookies Sie zulassen möchten.
        </p>
        <p className="font-display text-ink">Notwendige Cookies</p>
        <p>
          Notwendige Cookies sind für den Betrieb der Website technisch erforderlich und können nicht
          deaktiviert werden. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
        </p>
        <p className="font-display text-ink">Funktionale, Analyse- und Marketing-Cookies</p>
        <p>
          Diese Cookies werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt. Rechtsgrundlage: Art. 6
          Abs. 1 lit. a DSGVO.
        </p>
      </LegalSection>

      <LegalSection heading="5. Kontaktaufnahme">
        <p>
          Wenn Sie uns per E-Mail oder Kontaktformular kontaktieren, werden Ihre Angaben einschließlich
          der übermittelten personenbezogenen Daten ausschließlich zur Bearbeitung Ihrer Anfrage
          verarbeitet. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO oder Art. 6
          Abs. 1 lit. f DSGVO.
        </p>
      </LegalSection>

      <LegalSection heading="6. Ihre Rechte">
        <p>Sie haben jederzeit das Recht:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Auskunft über Ihre gespeicherten personenbezogenen Daten zu erhalten</li>
          <li>Berichtigung unrichtiger Daten zu verlangen</li>
          <li>Löschung Ihrer Daten zu verlangen</li>
          <li>Einschränkung der Verarbeitung zu verlangen</li>
          <li>Datenübertragbarkeit zu verlangen</li>
          <li>Widerspruch gegen die Verarbeitung einzulegen</li>
          <li>Eine erteilte Einwilligung jederzeit zu widerrufen</li>
          <li>Sich bei einer zuständigen Datenschutzaufsichtsbehörde zu beschweren</li>
        </ul>
      </LegalSection>

      <LegalSection heading="7. Datensicherheit">
        <p>
          Diese Website nutzt eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
          Sie an der Adresszeile Ihres Browsers und dem Schloss-Symbol.
        </p>
      </LegalSection>

      <LegalSection heading="8. Änderung dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an rechtliche oder
          technische Änderungen anzupassen.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
